<template>
    <section v-show="active" class="tab-panel">
        <slot />
    </section>
</template>
<script>

export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        content: {
            type: Object,
            default: () => {},
        },
        canChange: {
            type: Function,
            default: () => true,
        },
    },

    data() {
        return {
            /**
             * @type {boolean}
             */
            active: false,
        }
    },
}

</script>
